import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { loadImg } from '@/utils/image';
export default {
  name: 'ReminderPublicModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data: function data() {
    return {
      canvasImg: null,
      // canvas
      pic: {
        title: '标题',
        color: {
          top: '#fff',
          bottom: 'yellow',
          number: 'yellow'
        },
        number: '2000',
        label: '火星大集结啊啊啊啊啊啊啊!',
        picUrl: '',
        logo: 'https://static.meituan.net/bs/myfe/wxapp/file/images/show/newDetail/reminder-public/logo@3x_2.png',
        qr: '',
        yinhao: 'https://static.meituan.net/bs/myfe/wxapp/file/images/show/newDetail/reminder-public/yinhao@3x.png',
        yinhaoBak: 'https://static.meituan.net/bs/myfe/wxapp/file/images/show/newDetail/reminder-public/yinhao-bak@3x.png'
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.data) {
      var _this$data = this.data,
        bottom = _this$data.bottom,
        color = _this$data.color,
        picUrl = _this$data.picUrl,
        qr = _this$data.qr,
        top = _this$data.top,
        number = _this$data.number;
      this.pic = Object.assign({}, this.pic, {
        title: top,
        label: bottom,
        qr: qr,
        color: color,
        number: String(number),
        picUrl: picUrl
      });
      try {
        this.drawImg();
      } catch (e) {
        this.$loading.close();
      }
    }
  },
  methods: {
    // 绘制图片
    drawImg: function drawImg() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var c, _this$pic, title, picUrl, logo, qr, color, number, label, yinhao, yinhaoBak, pixel, ctx, picUrlImg, logoImg, labelSplit, wordLength, yinhaoImg, yinhaoBakImg, qrImg;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$loading('正在生成图片...');
              c = document.createElement('canvas');
              _this$pic = _this.pic, title = _this$pic.title, picUrl = _this$pic.picUrl, logo = _this$pic.logo, qr = _this$pic.qr, color = _this$pic.color, number = _this$pic.number, label = _this$pic.label, yinhao = _this$pic.yinhao, yinhaoBak = _this$pic.yinhaoBak;
              pixel = window.devicePixelRatio;
              c.width = 750;
              c.height = 1334;
              ctx = c.getContext('2d');
              _context.next = 9;
              return loadImg(picUrl, 'Anonymous');
            case 9:
              picUrlImg = _context.sent;
              ctx.drawImage(picUrlImg, 0, 0, 750, 1334);
              _context.next = 13;
              return loadImg(logo, 'Anonymous');
            case 13:
              logoImg = _context.sent;
              ctx.drawImage(logoImg, 50, 1200, 147, 42);
              ctx.font = 'italic 30px PingFangSC-Medium';
              ctx.fillStyle = color.top;
              ctx.fillText('我是', 50, 150);
              ctx.fillStyle = color.number;
              ctx.fillText('第', 110, 150);
              ctx.font = 'italic 72px PingFangSC-Medium';
              ctx.fillText(number, 145, 150);
              ctx.font = 'italic 30px PingFangSC-Medium';
              ctx.fontWeight = 400;
              ctx.fillText('位', 147 + 40.5 * number.length, 150);
              ctx.fillStyle = color.top;
              ctx.fillText(title, 50, 200);
              ctx.fillStyle = 'rgba(255,255,255,0.8)';
              ctx.font = 'normal 20px PingFangSC-Medium';
              ctx.fillText('微信扫码或长按', 430, 1210);
              ctx.fillText('立即预约抢票', 450, 1242);
              if (!label) {
                _context.next = 41;
                break;
              }
              labelSplit = label.split(' ');
              wordLength = 0;
              _context.next = 36;
              return loadImg(yinhao, 'Anonymous');
            case 36:
              yinhaoImg = _context.sent;
              _context.next = 39;
              return loadImg(yinhaoBak, 'Anonymous');
            case 39:
              yinhaoBakImg = _context.sent;
              if (labelSplit.length > 1) {
                wordLength = labelSplit[0].length > labelSplit[1].length ? labelSplit[0].length : labelSplit[1].length;
                ctx.font = 'italic 30px PingFangSC-Medium';
                ctx.fillStyle = color.bottom;
                ctx.textAlign = 'center';
                ctx.fillText(labelSplit[0], 375, 1040);
                ctx.fillText(labelSplit[1], 375, 1080);
                ctx.drawImage(yinhaoImg, 360 + 16 * wordLength + 18, 1075, 45, 33);
                ctx.drawImage(yinhaoBakImg, 345 - 16 * wordLength - 18, 1005, 45, 33);
              } else {
                wordLength = labelSplit[0].length;
                ctx.font = 'italic 30px PingFangSC-Medium';
                ctx.fillStyle = color.bottom;
                ctx.textAlign = 'center';
                ctx.fillText(labelSplit[0], 375, 1080);
                ctx.drawImage(yinhaoImg, 360 + 16 * wordLength + 18, 1075, 45, 33);
                ctx.drawImage(yinhaoBakImg, 345 - 16 * wordLength - 18, 1035, 45, 33);
              }
            case 41:
              _context.next = 43;
              return loadImg(qr, 'Anonymous');
            case 43:
              qrImg = _context.sent;
              // ctx.drawImage( qrImg, 580, 1152, 130, 130 )
              ctx.beginPath(); // 开始绘制
              // 先画个圆   前两个参数确定了圆心 （x,y） 坐标  第三个参数是圆的半径  四参数是绘图方向  默认是false，即顺时针
              ctx.arc(130 / 2 + 580, 130 / 2 + 1152, 130 / 2, 0, Math.PI * 2, false);
              ctx.clip(); // 画好了圆 剪切  原始画布中剪切任意形状和尺寸。一旦剪切了某个区域，则所有之后的绘图都会被限制在被剪切的区域内 这也是我们要save上下文的原因
              ctx.drawImage(qrImg, 580, 1152, 130, 130); // 推进去图片，必须是https图片
              ctx.restore(); // 恢复之前保存的绘图上下文 恢复之前保存的绘图上下午即状态 还可以继续绘制
              _this.canvasImg = c.toDataURL('image/png');
              _this.$loading.close();
            case 51:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    close: function close() {
      console.log('close');
      this.$emit('closeEvent');
    },
    // 禁止穿透
    touchmove: function touchmove(event) {
      event.preventDefault();
    }
  }
};